import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { PreferenceSetEntity } from './preference-set.entity';
import { PreferenceEntity } from './preference.entity';

@Index('_fk__preference__id', ['fkPreferenceId'], {})
@Index('_fk__preference_set__id', ['fkPreferenceSetId'], {})
@Entity('_preference_set_default')
export class PreferenceSetDefaultEntity extends BaseEntity {
	@Column('int', { name: '_fk__preference__id', unsigned: true })
	public fkPreferenceId!: number;

	@Column('int', {
		name: '_fk__object__id_reference',
		unsigned: true,
		default: () => "'0'",
	})
	public fkObjectIdReference!: number;

	@Column('int', { name: '_referenceId', unsigned: true, default: () => "'0'" })
	public referenceId!: number;

	@Column('int', { name: '_fk__preference_set__id', unsigned: true })
	public fkPreferenceSetId!: number;

	@ManyToOne(
		() => PreferenceEntity,
		(preference) => preference.preferenceSetDefaults,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([{ name: '_fk__preference__id', referencedColumnName: 'id' }])
	public fkPreference!: PreferenceEntity;

	@ManyToOne(
		() => PreferenceSetEntity,
		(preferenceSet) => preferenceSet.preferenceSetDefaults,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([{ name: '_fk__preference_set__id', referencedColumnName: 'id' }])
	public fkPreferenceSet!: PreferenceSetEntity;
}
